// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_3GZpCN","card":"_1I80jk","cardHeading":"OsTPVt","cardTitle":"_1Vc2i5","titleChronicle":"_3svLBH","cardSubtitle":"_23_U7O","cardIcon":"_14DDyp"};